module.exports = __webpack_public_path__ + "assets/img/mecha-btn-17f33073.png";